export default __webpack_public_path__ + "static/media/Diogo.c096ba19.png";